var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo && _vm.isRepx != null
    ? _c("div", [
        _c("div", { staticClass: "tile is-parent" }, [
          _c("div", { staticClass: "tile is-child" }, [
            _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column" },
                [
                  _vm._m(0),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "steps is-vertical is-narrow is-centered has-content-centered",
                    },
                    _vm._l(_vm.mappedSteps, function (step, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "steps-segment",
                          class: { "is-active": index == _vm.currentStep },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "has-text-dark",
                              attrs: { href: "#" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "steps-marker",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleRepXStepModal(
                                        step,
                                        index
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(index) + " ")]
                              ),
                              _c("div", { staticClass: "steps-content" }, [
                                _c("p", { staticClass: "heading" }, [
                                  _c("b", [_vm._v(_vm._s(step.step))]),
                                ]),
                                step.stepDate != null
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "tags has-addons",
                                        staticStyle: { width: "max-content" },
                                      },
                                      [
                                        step.updateBy != null
                                          ? _c(
                                              "span",
                                              { staticClass: "tag is-dark" },
                                              [_vm._v(_vm._s(step.updateBy))]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          { staticClass: "tag is-success" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$filters.formatDateTimeLocale(
                                                  step.stepDate,
                                                  _vm.$userInfo.locale
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm.selectedRepXStepItem && _vm.isRepXStepModalActive
                    ? _c(
                        "confirm-modal",
                        {
                          attrs: {
                            active: _vm.isRepXStepModalActive,
                            "ok-text": "Yes",
                            "cancel-text": "No",
                          },
                          on: {
                            "update:active": function ($event) {
                              _vm.isRepXStepModalActive = $event
                            },
                            ok: function ($event) {
                              return _vm.save()
                            },
                            cancel: function ($event) {
                              return _vm.toggleRepXStepModal(false)
                            },
                          },
                          model: {
                            value: _vm.selectedRepXStepItem,
                            callback: function ($$v) {
                              _vm.selectedRepXStepItem = $$v
                            },
                            expression: "selectedRepXStepItem",
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              attrs: { slot: "text-title" },
                              slot: "text-title",
                            },
                            [
                              _vm._v(
                                "Job Status - " +
                                  _vm._s(_vm.selectedRepXStepItem.step)
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              attrs: { slot: "text-content" },
                              slot: "text-content",
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.selectedRepXStepItem.step)),
                              ]),
                              _vm._v(
                                " job will be update to completed. Continue? "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  false
                    ? _c(
                        "base-modal-ex",
                        {
                          attrs: {
                            "min-height": 55,
                            "min-width": 30,
                            active: _vm.isRepXStepModalActive,
                            "can-cancel": false,
                            "has-modal-card": "",
                            name: "RepXStepModal",
                          },
                          on: {
                            "update:active": function ($event) {
                              _vm.isRepXStepModalActive = $event
                            },
                            cancel: function ($event) {
                              return _vm.toggleRepXStepModal(null)
                            },
                          },
                        },
                        [
                          _c("header", { staticClass: "modal-card-head" }, [
                            _c("p", { staticClass: "modal-card-title" }, [
                              _c("span", [_vm._v("Job Status")]),
                            ]),
                          ]),
                          _c(
                            "section",
                            { staticClass: "modal-card-body" },
                            [
                              _c("pre", [
                                _vm._v(_vm._s(_vm.selectedRepXStepItem)),
                              ]),
                              _c("label", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.selectedRepXStepItem.step)),
                              ]),
                              _c("v-date-picker", {
                                ref: "datepicker",
                                staticClass: "is-fullwidth",
                                attrs: {
                                  "is-dark": _vm.$theme.isDark,
                                  mode: "dateTime",
                                  "minute-increment": 30,
                                  masks: _vm.formats,
                                  attributes: _vm.attrs,
                                  locale: _vm.$userInfo.locale,
                                  "model-config": _vm.selectedRepXStepItem,
                                  timezone: _vm.$filters.getIanaTimezone(),
                                  "min-date": _vm.minDate,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({
                                        inputValue,
                                        inputEvents,
                                      }) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "field has-addons" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "control is-expanded has-icons-left",
                                                },
                                                [
                                                  _c(
                                                    "input",
                                                    _vm._g(
                                                      {
                                                        ref: "stepDate",
                                                        staticClass: "input",
                                                        attrs: {
                                                          type: "text",
                                                          placeholder:
                                                            _vm
                                                              .selectedRepXStepItem
                                                              .step,
                                                          readonly: "",
                                                        },
                                                        domProps: {
                                                          value: inputValue,
                                                        },
                                                      },
                                                      inputEvents
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "icon is-small is-left",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "mdi mdi-calendar mdi-18px",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "control" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "button tooltip",
                                                      attrs: {
                                                        "data-tooltip":
                                                          "Reset dates",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearStartDate(
                                                            "stepDate"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "icon" },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "mdi mdi-close mdi-24px",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3253090168
                                ),
                                model: {
                                  value: _vm.selectedRepXStepItem.stepDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectedRepXStepItem,
                                      "stepDate",
                                      $$v
                                    )
                                  },
                                  expression: "selectedRepXStepItem.stepDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "footer",
                            {
                              staticClass:
                                "modal-card-foot is-flex is-justify-content-flex-end",
                            },
                            [
                              _c("div", { staticClass: "buttons" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button is-success tooltip",
                                    attrs: { "data-tooltip": "Save" },
                                    on: { click: _vm.save },
                                  },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-content-save mdi-20px",
                                      }),
                                    ]),
                                    _c("span", [_vm._v("Save")]),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "button tooltip",
                                    attrs: { "data-tooltip": "Close" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleRepXStepModal(null)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("i", {
                                        staticClass: "mdi mdi-20px mdi-close",
                                      }),
                                    ]),
                                    _c("span", [_vm._v("Close")]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("div", [
        _c("span", { staticClass: "subtitle is-inline-block" }, [
          _vm._v("Job Status"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }